import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view event on every SPA route change.
// The <script> tag in index.html loads gtag globally; here we just track history changes.
const GA_ID = "G-5H221Z6RLZ";

const GAListener = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default GAListener;
